import { CRITERIA_STATUS_FILTER_ALL, UNDER_ASSESSMENT_FILTER } from './constants'

const getItemTaxonomicGroup = (species) => species.taxonomicGroup || species.taxonGroup

const normalizeTaxonomicGroupFilter = (taxonomicGroup) => {
  if (!taxonomicGroup || taxonomicGroup === 'all') {
    return null
  }

  return String(taxonomicGroup).trim().toLowerCase()
}

export const filterSpecies = (speciesList = [], filters = {}) => {
  const {
    taxonomicGroup = 'all',
    criteriaStatus = CRITERIA_STATUS_FILTER_ALL,
    underAssessment = UNDER_ASSESSMENT_FILTER.ALL
  } = filters

  const normalizedTaxonomicGroup = normalizeTaxonomicGroupFilter(taxonomicGroup)

  return speciesList.filter((species) => {
    if (
      normalizedTaxonomicGroup &&
      String(getItemTaxonomicGroup(species) || '').trim().toLowerCase() !== normalizedTaxonomicGroup
    ) {
      return false
    }

    if (
      criteriaStatus &&
      criteriaStatus !== CRITERIA_STATUS_FILTER_ALL &&
      species.criteriaStatus !== criteriaStatus
    ) {
      return false
    }

    if (underAssessment === UNDER_ASSESSMENT_FILTER.UNDER && species.underAssessment !== true) {
      return false
    }

    if (underAssessment === UNDER_ASSESSMENT_FILTER.NOT_UNDER && species.underAssessment === true) {
      return false
    }

    return true
  })
}

export const getTaxonomicGroupOptions = (speciesList = []) => {
  const groups = [...new Set(
    speciesList
      .map(getItemTaxonomicGroup)
      .filter((group) => group != null && String(group).trim() !== '')
  )]

  return groups.sort((left, right) => String(left).localeCompare(String(right)))
}
